module.exports = __webpack_public_path__ + "img/arrow-right.7b9e5d96.svg";